/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_PhoneInputs */

const vi_shop_home_link_phone = /** @type {(inputs: Shop_Home_Link_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại`)
};

/**

* @param {Shop_Home_Link_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_phone = /** @type {((inputs?: Shop_Home_Link_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_phone(inputs)
});